module.exports = __webpack_public_path__ + "static/honei_logo-514eca4bf1063759a59a72a6531b6c0b.png";